import { render, staticRenderFns } from "./visitRecordList.vue?vue&type=template&id=2ef9bc1f&"
import script from "./visitRecordList.vue?vue&type=script&lang=js&"
export * from "./visitRecordList.vue?vue&type=script&lang=js&"
import style0 from "./visitRecordList.vue?vue&type=style&index=0&id=2ef9bc1f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports